import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore, faFileAlt, faTrophy } from '@fortawesome/free-solid-svg-icons';
import TemplateMarketplace from '../templates/TemplateMarketplace';
import VendorMarketplace from './VendorMarketplace';

export default function QuickActions() {
  const navigate = useNavigate();
  const [showTemplates, setShowTemplates] = useState(false);
  const [showVendors, setShowVendors] = useState(false);

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <button
          onClick={() => setShowTemplates(true)}
          className="bg-white border-2 border-border rounded-xl p-4 hover:border-primary transition-all text-left group"
        >
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center group-hover:bg-primary/20 transition-colors">
              <FontAwesomeIcon icon={faFileAlt} className="text-primary" />
            </div>
            <h3 className="font-bold text-text-primary">Templates</h3>
          </div>
          <p className="text-sm text-text-secondary">
            Browse planning templates to jumpstart your experiences
          </p>
        </button>

        <button
          onClick={() => setShowVendors(true)}
          className="bg-white border-2 border-border rounded-xl p-4 hover:border-primary transition-all text-left group"
        >
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center group-hover:bg-primary/20 transition-colors">
              <FontAwesomeIcon icon={faStore} className="text-primary" />
            </div>
            <h3 className="font-bold text-text-primary">Vendors</h3>
          </div>
          <p className="text-sm text-text-secondary">
            Find vendors for catering, photography, venues, and more
          </p>
        </button>

        <button
          onClick={() => navigate('/achievements')}
          className="bg-white border-2 border-border rounded-xl p-4 hover:border-primary transition-all text-left group"
        >
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center group-hover:bg-accent/20 transition-colors">
              <FontAwesomeIcon icon={faTrophy} className="text-accent" />
            </div>
            <h3 className="font-bold text-text-primary">Achievements</h3>
          </div>
          <p className="text-sm text-text-secondary">
            View your goals, badges, and milestones
          </p>
        </button>
      </div>

      {/* Template Marketplace Modal */}
      {showTemplates && (
        <TemplateMarketplace
          onSelectTemplate={(template) => {
            // Navigate to create experience with template
            navigate('/', { state: { openCreateModal: true, selectedTemplate: template } });
            setShowTemplates(false);
          }}
          onClose={() => setShowTemplates(false)}
        />
      )}

      {/* Vendor Marketplace Modal */}
      {showVendors && (
        <VendorMarketplace
          onSelectVendor={(vendor) => {
            // Could navigate to vendor detail or just close
            setShowVendors(false);
          }}
          onClose={() => setShowVendors(false)}
        />
      )}
    </>
  );
}
